import {
  Box,
  Button,
  Container,
  Modal,
  Typography,
  useTheme,
} from "@mui/material";
import CloseIcon from "../../icons/close";

export function ActionsModal(props) {
  const {
    palette: {
      secondary: { main: secondaryMain },
    },
  } = useTheme();

  const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "5px",
    outline: 0,
  };

  return (
    <Modal
      open={props.isOpen}
      data-testid={"actions-modal"}
      onClose={props.onClose}
    >
      <Box
        sx={modalStyles}
        key={"modal-form"}
        component={"form"}
        data-testid={"actions-form"}
        onSubmit={props.onSubmit}
        className="hardware-app"
      >
        <Container
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "30px",
          }}
        >
          <Typography variant={"h3"} color={"primary.main"} fontSize={"22px"}>
            {props.heading}
          </Typography>
          <Button
            onClick={props.onClose}
            aria-label={"close button"}
            disableRipple
            sx={{
              minWidth: 0,
              padding: "0",
              margin: "0",
              "&:hover": {
                backgroundColor: "#fff",
              },
              alignItems: "flex-start",
            }}
          >
            <CloseIcon />
          </Button>
        </Container>
        <Typography
          variant={"h4"}
          color={"secondary.main"}
          sx={{ marginBottom: "25px", fontWeight: 600 }}
        >
          {props.title}
        </Typography>
        {props.children}
        <Button
          disabled={!props.isFormValid}
          variant={"contained"}
          disableRipple
          color={"secondary"}
          sx={{
            display: "block",
            fontSize: "15px",
            padding: "8px 16px",
            borderRadius: "5px",
            margin: "0 auto",
            "&:hover": {
              backgroundColor: secondaryMain,
            },
            cursor: "pointer",
          }}
          type={"submit"}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
}
